import { getRetailUnitAndLanguage } from '../network/utils/getRetailUnitAndLanguage';
import { getEnv } from './env';

export function getBaseUrl(href: string, newPort?: string) {
  const matches = /(https?:\/\/.+?\/[a-z]{2}\/[a-z]{2})\/?/.exec(href);
  const baseUrl = matches?.[1];

  if (!baseUrl) {
    throw new Error(`The href is not of the correct format "${globalThis.location.href}"`);
  }

  return baseUrl.includes('localhost') && newPort ? baseUrl.replace(/:\d{4}/, `:${newPort}`) : baseUrl;
}

export function getAuthServiceUrl() {
  const { language, retailUnit } = getRetailUnitAndLanguage();

  const suffix = `${retailUnit}/${language}/auth`;

  const env = getEnv();

  if (env === 'development') {
    return 'https://localhost.ikeadt.com:3009';
  }

  if (env === 'qa') {
    return 'https://www.cte.ikeadt.com/' + suffix;
  }

  return 'https://ikea.marat.qd.je/' + suffix;
}

export function getGuestServiceUrl() {
  const env = getEnv();
  if (env === 'qa' || env === 'development') {
    return 'https://api.commerce.ikeadt.com/guest';
  }
  return 'https://api.commerce.ikea.com/guest';
}

export function getSessionContextUrl() {
  const { language, retailUnit } = getRetailUnitAndLanguage();
  const env = getEnv();

  if (env === 'qa' || env === 'development') {
    return `https://api.commerce.ikeadt.com/${retailUnit}/${language}/sessionContext/`;
  }

  return `https://api.commerce.ikea.com/${retailUnit}/${language}/sessionContext/`;
}

export function getGuestJwksUrl() {
  const env = getEnv();
  if (env === 'qa' || env === 'development') {
    return 'https://iows.cte.ikeadt.com/retail/iows/.well-known/jwks.json';
  }
  return 'https://iows.ikea.com/retail/iows/.well-known/jwks.json';
}

export function pathJoin(...paths: string[]) {
  let output = paths[0] ?? '';

  for (let i = 1; i < paths.length; i++) {
    const path = paths[i];
    const lastPathEndsWithSlash = output.endsWith('/');
    const nextPathStartsWithSlash = path.startsWith('/');

    if (!path) {
      continue;
    }

    if (lastPathEndsWithSlash && nextPathStartsWithSlash) {
      output += path.slice(1);
    } else if (!lastPathEndsWithSlash && !nextPathStartsWithSlash) {
      output += '/' + path;
    } else {
      output += path;
    }
  }

  return output.endsWith('/') ? output : output + '/';
}

export function toUrl(path: string, searchParams: Record<string, string>) {
  const url = new URL(path);

  for (const [key, value] of Object.entries(searchParams)) {
    url.searchParams.set(key, value);
  }

  return url.toString();
}
